module.exports = __webpack_public_path__ + "img/85694C_D1A67A_3C2F22_EBBF8F-256px.3d1209df.png";